import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';

import App from './app';

const rootNode = document.getElementById('app');

ReactDOM.render(<HashRouter>
    <App />
  </HashRouter>, rootNode);